const softwareServicesData = [
  {
    title: "Custom Software Development",
    description: "Tailored solutions aligned to your business goals.",
    bullets: ["Discovery", "MVP/Scale", "Security", "CI/CD"],
    minHeight: 400,
  },
  {
    title: "Product Modernization",
    description: "Re‑platform and refactor legacy to modern stacks.",
    bullets: ["Cloud Native", "Microservices", "Observability", "Migration"],
    minHeight: 400,
  },
  {
    title: "Integrations",
    description: "Reliable integrations with ERPs, CRMs, payments.",
    bullets: ["REST/GraphQL", "Webhooks", "ETL/ELT", "Queues"],
    minHeight: 400,
  },
  {
    title: "Quality Engineering",
    description: "Automated testing and performance engineering.",
    bullets: ["Unit/E2E", "Load", "SAST/DAST", "Hardening"],
    minHeight: 400,
  },
  {
    title: "Data & Analytics",
    description: "Warehouses, dashboards, and realtime insights.",
    bullets: ["Modeling", "Pipelines", "BI", "Realtime"],
    minHeight: 400,
  },
  {
    title: "Support & Maintenance",
    description: "SRE, SLAs, and continuous improvements.",
    bullets: ["SRE", "SLAs", "Patching", "Roadmap"],
    minHeight: 400,
  },
];

export default softwareServicesData;
